<template>
  <b-card>
    <b-card-title class="d-flex justify-content-between align-items-center">
      <h4 class="text-center">
        Driver
      </h4>
      <div class="d-flex ">
        <b-button
          :disabled="!driver.id"
          class="btn-icon rounded-circle"
          variant="flat-primary"
          @click="$router.push({
            path: `/drivers/${driver.id}?externalId=${driver.external_id}`
          })"
        >
          <feather-icon
            icon="UserIcon"
          />
        </b-button>
        <b-button
          :disabled="!driver.id"
          class="btn-icon rounded-circle"
          variant="flat-primary"
          @click="$router.push({
            path: `/drivers/${driver.id}?externalId=${driver.external_id}`,
            query: { 'active-tab' :'wallet' }
          })"
        >
          <feather-icon
            icon="BriefcaseIcon"
          />
        </b-button>
      </div>
    </b-card-title>
    <hr>
    <!--  -->
    <b-row>
      <b-col
        v-for="(item, idx) in pickFrom"
        :key="idx"
        md="12"
        class="mb-1"
      >
        <span class="font-weight-bold">{{ item.label }}: </span> {{ item.key(driver) ? item.key(driver) : '_' }}
      </b-col>
      <b-col
        md="12"
        class="mt-2 mb-1"
      >
        <h3>Car Details</h3>
      </b-col>
      <b-col
        md="8"
        class="mb-2"
      >
        <strong>Car Number: </strong> {{ driver.car.car_number && driver.car.car_number }}
      </b-col>
      <b-col md="4">
        <strong>Color: </strong> {{ driver.car.color && driver.car.color }}
      </b-col>
      <b-col md="4">
        <strong>Make: </strong> {{ driver.car.make && driver.car.make }}
      </b-col>
      <b-col md="4">
        <strong>Model: </strong> {{ driver.car.model && driver.car.model }}
      </b-col>
      <b-col md="4">
        <strong>Year: </strong> {{ driver.car.year && driver.car.year }}
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle, BRow, BCol, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardTitle,
    BRow,
    BCol,
    BButton,
  },
  props: {
    driver: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const pickFrom = [
      {
        key: el => `${el?.first_name} ${el?.last_name}`,
        label: 'Name',
      },
      {
        key: el => el?.phone_number,
        label: 'Phone Number',
      },
      {
        key: el => el?.driver_id,
        label: 'Number',
      },
    ]

    return {
      pickFrom,
    }
  },
}
</script>

  <style scoped>
  .driver-info__no-driver {
      height: 60%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
  }
  </style>
